import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class DocumentService {

    private apiUrl = `${process.env['APIURL']}/admin/documents/v1/documents`;

    constructor(private http: HttpClient) {}

    getData(start? : number, pages? : number, searchVal? : number, type? : string): Observable<any> {
        let requestUrl = `${this.apiUrl}`
        requestUrl+=`?start=${start}&pages=${pages}`;
        if (searchVal) {
            requestUrl+=`&searchVal=${searchVal}`;
        } 
        if (type) {
            requestUrl+=`&type=${type}`;
        }
        return this.http.get<any>(requestUrl)
    }
}
